import api from './api';

export interface TipoDocumento {
  id: number;
  nome: string;
  descricao: string | null;
  icone: string | null;
  ordem: number;
  count?: number;
}

export interface Unidade {
  id: number;
  nome: string;
  active: boolean;
}

export interface Document {
  id: string;
  nome: string;
  arquivo: string;
  dataReferencia: string;
  createdAt: string;
  tipoDocumento: TipoDocumento;
  unidade: Unidade | null;
  client?: {
    id: string;
    razaoSocial: string;
  };
}

export interface DocumentListResponse {
  data: Document[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface DocumentFilters {
  tipoDocumentoId?: number;
  unidade?: number;
  dataInicio?: string; // YYYY-MM-DD
  dataFim?: string;    // YYYY-MM-DD
  search?: string;
  page?: number;
  limit?: number;
}

export const documentService = {
  async list(filters: DocumentFilters = {}): Promise<DocumentListResponse> {
    const params = new URLSearchParams();
    if (filters.tipoDocumentoId) params.append('tipoDocumentoId', filters.tipoDocumentoId.toString());
    if (filters.unidade) params.append('unidade', filters.unidade.toString());
    if (filters.dataInicio) params.append('dataInicio', filters.dataInicio);
    if (filters.dataFim) params.append('dataFim', filters.dataFim);
    if (filters.search) params.append('search', filters.search);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());

    const response = await api.get<DocumentListResponse>(`/documents?${params}`);
    return response.data;
  },

  async getStats(): Promise<TipoDocumento[]> {
    const response = await api.get<TipoDocumento[]>('/documents/stats');
    return response.data;
  },

  async getById(id: string): Promise<Document> {
    const response = await api.get<Document>(`/documents/${id}`);
    return response.data;
  },

  getViewUrl(id: string): string {
    const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
    return `${baseUrl}/documents/${id}/view`;
  },

  getDownloadUrl(id: string): string {
    const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
    return `${baseUrl}/documents/${id}/download`;
  },

  async downloadFile(id: string, filename?: string): Promise<void> {
    try {
      const response = await api.get(`/documents/${id}/download`, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename || 'documento');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar documento:', error);
      alert('Erro ao baixar documento. Tente novamente.');
    }
  },

  async viewFile(id: string): Promise<void> {
    try {
      const response = await api.get(`/documents/${id}/view`, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (error) {
      console.error('Erro ao visualizar documento:', error);
      alert('Erro ao visualizar documento. Tente novamente.');
    }
  },

  async getTiposDocumento(): Promise<TipoDocumento[]> {
    const response = await api.get<TipoDocumento[]>('/categorias');
    return response.data;
  },
};
